import { useState } from 'react'

import { InstrumentDto } from '@/gen/publicApi'

import { Card, CardFooter } from '@/components/card'

import DailyHistory from './dailyHistory'
import MinuteHistory from './minuteHistory'
import HistoryToggle from './toggle'

interface Props {
    clientCode: string
    marketCode: string
    instrument: InstrumentDto
}

const parseToggleValue = (toggleValue: string) => {
    const lastChar = toggleValue.slice(-1)
    const value = parseInt(toggleValue.slice(0, -1))

    switch (lastChar) {
        case 'm':
            return {
                type: 'minutes',
                value,
            }
        case 'h':
            return {
                type: 'minutes',
                value: value * 60,
            }

        case 'd':
            return {
                type: 'days',
                value,
            }
        default:
            return {
                type: 'days',
                value,
            }
    }
}

export default function InstrumentHistory({ clientCode, marketCode, instrument }: Props) {
    const [dayValue, setDayValue] = useState('7d')
    const parsedValue = parseToggleValue(dayValue)
    return (
        <Card className="col-span-2 h-96">
            {parsedValue.type === 'days' && (
                <DailyHistory
                    clientCode={clientCode}
                    marketCode={marketCode}
                    instrumentSymbol={instrument.symbol}
                    dayValue={parsedValue.value}
                />
            )}
            {parsedValue.type === 'minutes' && (
                <MinuteHistory
                    clientCode={clientCode}
                    marketCode={marketCode}
                    instrumentSymbol={instrument.symbol}
                    minuteValue={parsedValue.value}
                />
            )}

            <CardFooter className="flex justify-end">
                <HistoryToggle value={dayValue} onChange={setDayValue} />
            </CardFooter>
        </Card>
    )
}
